module.exports = "/build/web/svg/event/thuiswedstrijd.3e510e488c53982432915a8636300e86.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/thuiswedstrijd.svg
// module id = 160
// module chunks = 24